import { Box, Stack, Typography, TextField, FormControl } from "@mui/material";
import React, { useState } from "react";
import Selector from "../Selector";

const RevenueShareModel = ({ formik }) => {
	const [milestonePercentages, setMilestonePercentages] = useState({
		1: "",
	});

	const handlePercentageChange = (milestoneNum, value) => {
		setMilestonePercentages((prev) => ({
			...prev,
			[milestoneNum]: value,
		}));
	};
	const handlePartySumValidation = () => {
		const { partyA, partyB } = formik.values;
		if (formik.touched.partyA && formik.touched.partyB) {
			if ((partyA || 0) + (partyB || 0) !== 100) {
				return "The sum of Party A and Party B must be 100";
			}
		}
		return null;
	};

	const partySumError = handlePartySumValidation();

	return (
		<Box>
			<Typography sx={{ margin: "10px 0px" }}>
				Payment Plan
				<span style={{ color: "red", marginLeft: "5px" }}>*</span>
			</Typography>
			<Typography sx={{ margin: "10px 0px" }}>
				Percentage of Revenue share
				<span style={{ color: "red", marginLeft: "5px" }}>*</span>
			</Typography>
			<Stack direction={{ xs: "column", sm: "row" }} spacing={3} mb={4}>
				<FormControl
					sx={{
						minWidth: 200,
					}}
				>
					<Stack direction={"row"} alignItems={"center"}>
						{" "}
						<label style={{ margin: "10px 0px", flexShrink: 0 }}>
							Party A:
							<span style={{ color: "red", marginLeft: "5px" }}>
								*
							</span>
						</label>
						<TextField
							fullWidth
							type="number"
							name="partyA"
							placeholder="Enter percentage %"
							helperText="Enter percentage (0-100)"
							onChange={formik.handleChange}
						/>
					</Stack>
					{formik.errors?.partyA && formik.touched?.partyA && (
						<Typography variant="caption" color="error">
							{formik.errors?.partyA}
						</Typography>
					)}
				</FormControl>

				<FormControl sx={{ minWidth: 200 }}>
					<Stack direction={"row"} alignItems={"center"}>
						<label style={{ margin: "10px 0px", flexShrink: 0 }}>
							Party B :
							<span style={{ color: "red", marginLeft: "5px" }}>
								*
							</span>
						</label>
						<TextField
							fullWidth
							type="number"
							name="partyB"
							placeholder="Enter percentage %"
							helperText="Enter percentage (0-100)"
							onChange={formik.handleChange}
						/>
					</Stack>
					{formik.errors?.partyB && formik.touched?.partyB && (
						<Typography variant="caption" color="error">
							{formik.errors?.partyB}
						</Typography>
					)}
				</FormControl>
			</Stack>
			{partySumError && (
				<Typography variant="caption" color="error">
					{partySumError}
				</Typography>
			)}
			<Selector
				noneValue={"Select Payment Plan"}
				label={"Payment Plan"}
				options={[
					{ label: "Quarterly", value: "Quarterly" },
					{ label: "Bi-Annual", value: "BiAnnual" },
					{ label: "Pay as you earn", value: "PayAndEarn" },
				]}
				name={"paymentPlan"}
				formik={formik}
			/>
		</Box>
	);
};

export default RevenueShareModel;
